export default "__VITE_ASSET__7558fb56__"